import React from 'react';
import productDetailsClasses from 'swag-client-common/styles/product-details.scss';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import classNames from 'classnames';
import SwitchButton from '../switch-button';
import CSSclasses from '../../details.scss';
export const CustomizeBlank = ({
  number,
  isSuperSpeed,
  productionTimeList,
  isCustomizedBlank,
  isLimitedEdition,
  isDisabled,
  onChange
}) => {
  const isButtonDisabled = isBlankOption => !isBlankOption === isCustomizedBlank && isDisabled;
  const handlePrintedOptionChange = () => onChange({
    isBlank: false
  });
  const handleBlankOptionChange = () => onChange({
    isBlank: true,
    isSuperSpeed,
    productionTimeList
  });
  const getButtonClassName = isBlank => isLimitedEdition && isBlank === isCustomizedBlank ? CSSclasses.limitedEditionBtn : '';
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(productDetailsClasses.block, productDetailsClasses.customizeContainer),
    "data-block": "MainProductCustomizedBlank"
  }, /*#__PURE__*/React.createElement("h5", {
    className: productDetailsClasses.blockTitle
  }, /*#__PURE__*/React.createElement("span", {
    className: productDetailsClasses.number
  }, number), "Want this customized?"), /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.fullRow
  }, /*#__PURE__*/React.createElement(SwitchButton, {
    isActive: !isCustomizedBlank,
    disabled: isButtonDisabled(false),
    dataButton: "Printed",
    onClick: handlePrintedOptionChange,
    className: getButtonClassName(false)
  }, "Printed"), /*#__PURE__*/React.createElement(Tooltip, {
    className: CSSclasses.switchButtonWithMargin,
    disableHoverListener: isCustomizedBlank,
    title: "The uploaded design disappears once you choose this option.",
    placement: Placement.TOP
  }, /*#__PURE__*/React.createElement(SwitchButton, {
    isActive: isCustomizedBlank,
    disabled: isButtonDisabled(true),
    dataButton: "Blank",
    onClick: handleBlankOptionChange,
    className: getButtonClassName(true)
  }, "Blank"))));
};